<template>
  <div class="audio-player">
    <a @click="player(url, $event)">
      <span class="btn-sound--small enabled" />
      <audio
        :src="url"
        style="display: none"
        @ended="handleSoundEnded($event)"
      />
    </a>
  </div>
</template>

<style lang="less" scoped>
.audio-player {
  display: inline-block;
  padding: 0 5px;
}
</style>


<script>
const debug = require('debug')('ccs:component:audio-player');

export default {
	props: {
		url: String
	},
	methods: {
		player(url, ev) {
			debug('[player] url: %s', url);
			let ele = ev.currentTarget.children[0];
			let voice = ev.currentTarget.children[1];
			if (ele && voice) {
				if (this.hasClass(ele, 'active')) {
					//已经在播放，点击时停止
					voice.src = ''; //停止
					this.deleteClass(ele, 'active');
					this.addClass(ele, 'enabled');
				} else {
					this.deleteClass(ele, 'enabled');
					this.addClass(ele, 'active');
					voice.src = url; //停止
					voice.play();
				}
			}
		},
		handleSoundEnded(ev) {
			let ele = ev.currentTarget.parentNode.children[0];
			if (ele) {
				this.deleteClass(ele, 'active');
				this.addClass(ele, 'enabled');
			}
		},
		hasClass(element, csName) {
			return element.className.match(RegExp('(\\s|^)' + csName + '(\\s|$)')); //使用正则检测是否有相同的样式
		},
		deleteClass(element, csName) {
			if (this.hasClass(element, csName)) {
				element.className = element.className.replace(
					RegExp('(\\s|^)' + csName + '(\\s|$)'),
					' '
				);
			}
		},
		addClass(element, csName) {
			if (!this.hasClass(element, csName)) {
				element.className += ' ' + csName;
			}
		}
	}
};
</script>

